module.exports = __webpack_public_path__ + "img/calendarGray.3dc1f0a.svg";